import { ConditionOperator } from 'src/graphql/types';

// there are some similarities with behaviors
// but actually some labels are different and additionally
// custom views have display label for chips, therefore decided to
// create a separate list of operators
export const customViewOperators = [
  {
    label: 'Equals',
    display: 'is',
    value: ConditionOperator.Equals,
  },
  {
    label: 'Does Not Equal',
    display: 'is not',
    value: ConditionOperator.DoesNotEqual,
  },
  {
    label: 'Empty',
    display: 'is empty',
    value: ConditionOperator.Empty,
    arity: 'unary',
  },
  {
    label: 'Not Empty',
    display: 'is not empty',
    value: ConditionOperator.NotEmpty,
    arity: 'unary',
  },
  {
    label: 'Contains',
    display: 'contains',
    value: ConditionOperator.Contains,
  },
  {
    label: 'Does Not Contain',
    display: 'does not contain',
    value: ConditionOperator.DoesNotContain,
  },
  {
    label: 'Less Than',
    display: 'less than',
    value: ConditionOperator.LessThan,
  },
  {
    label: 'Greater Than',
    display: 'greater than',
    value: ConditionOperator.GreaterThan,
  },
  {
    label: 'Is',
    display: 'is any of',
    value: ConditionOperator.In,
    multi: true,
  },
  {
    label: 'Is not',
    display: 'is not any of',
    value: ConditionOperator.NotIn,
    multi: true,
  },
  {
    label: 'Equals',
    display: 'is',
    value: ConditionOperator.DateEquals,
  },
  {
    label: 'Does Not Equal',
    display: 'is not',
    value: ConditionOperator.DateDoesNotEqual,
  },
  {
    label: 'Greater Than',
    display: 'greater than',
    value: ConditionOperator.DateIsAfter,
  },
  {
    label: 'Less Than',
    display: 'less than',
    value: ConditionOperator.DateIsBefore,
  },
  {
    label: 'Less or Equal Than',
    display: 'less or equal than',
    value: ConditionOperator.DateLessOrEqualThan,
  },
  {
    label: 'Greater or Equal Than',
    display: 'greater or equal than',
    value: ConditionOperator.DateGreaterOrEqualThan,
  },
] as CustomViewOperator[];

export interface CustomViewOperator {
  label: string;
  display: string;
  value: ConditionOperator;
  multi: boolean;
  arity?: 'binary' | 'unary' | 'ternary';
}

export const customViewOperatorsMap = new Map(customViewOperators.map((i) => [i.value, i]));

export const isUnary = (operator?: ConditionOperator): boolean =>
  !!operator && customViewOperatorsMap.get(operator)?.arity === 'unary';

export const isMulti = (operator?: ConditionOperator): boolean =>
  !!operator && !!customViewOperatorsMap.get(operator)?.multi;

export const operatorDisplay = (operator?: ConditionOperator): string =>
  operator ? (customViewOperatorsMap.get(operator)?.display ?? '') : '';

export const customViewOperatorsByUiType = {
  list: [
    ConditionOperator.In,
    ConditionOperator.NotIn,
    ConditionOperator.Empty,
    ConditionOperator.NotEmpty,
  ].map((i) => customViewOperatorsMap.get(i)!),
  text: [
    ConditionOperator.Contains,
    ConditionOperator.DoesNotContain,
    ConditionOperator.Equals,
    ConditionOperator.DoesNotEqual,
    ConditionOperator.Empty,
    ConditionOperator.NotEmpty,
  ].map((i) => customViewOperatorsMap.get(i)!),
  number: [
    ConditionOperator.Equals,
    ConditionOperator.DoesNotEqual,
    ConditionOperator.Empty,
    ConditionOperator.NotEmpty,
    ConditionOperator.LessThan,
    ConditionOperator.GreaterThan,
  ].map((i) => customViewOperatorsMap.get(i)!),
  date: [
    ConditionOperator.DateEquals,
    ConditionOperator.DateDoesNotEqual,
    ConditionOperator.DateIsAfter,
    ConditionOperator.DateIsBefore,
    ConditionOperator.DateGreaterOrEqualThan,
    ConditionOperator.DateLessOrEqualThan,
  ].map((i) => customViewOperatorsMap.get(i)!),
} as const;

export const getOperatorsByUiType = (uiType?: string): CustomViewOperator[] =>
  customViewOperatorsByUiType[uiType as keyof typeof customViewOperatorsByUiType] ??
  customViewOperatorsByUiType.text;
